// src/pages/product/EditProduct.jsx

import React, {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  successToast,
  errorToast,
} from "../../Utils/toast";

import {
  useGetSingleProductQuery,
  useUpdateProductMutation,
} from "../../redux/services/productService/product.Services";
import { useProductDropdownData } from "./hooks/useProductDropdownData";
function EditProduct() {

  const navigate = useNavigate();

  const { id } = useParams();

  const { data, isLoading: productLoading, } = useGetSingleProductQuery(id);

  const product = data?.data;
  const [galleryPreview, setGalleryPreview] = useState([]);
  const [
    updateProduct,
    { isLoading },
  ] = useUpdateProductMutation();

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    categoryName: "",
    subcatName: "",
    stateName: "",
    cityName: "",
    location: "",
    amenities: [],
    bookingStatus: 0,
    price: "",
    guest: "",
    bedroom: "",
    bed: "",
    bathroom: "",
    address: "",
    latitude: "",
    longitude: "",
    rating: "",
    noOfReviews: "",
    status: "active",
    thumbnail_image: null,
    images: [],
  });
  const dropdowns = useProductDropdownData(formData);
  const [preview, setPreview] = useState(null);
  const cityNameSafe =
    product?.cityName && product.cityName !== "undefined"
      ? product.cityName
      : "";
  useEffect(() => {
    if (!product) return;

    const selectedCategory = dropdowns.categories.find(
      (cat) =>
        cat.slug?.toLowerCase() === product?.categoryName?.toLowerCase()
    );

    const selectedState = dropdowns.states.find(
      (state) =>
        state.name?.toLowerCase() === product?.stateName?.toLowerCase()
    );

    setFormData((prev) => ({
      ...prev,

      id: product?.id,
      title: product?.title || "",
      description: product?.description || "",
      price: product?.price || "",
      guest: product?.guest || "",
      bedroom: product?.bedroom || "",
      bed: product?.bed || "",
      bathroom: product?.bathroom || "",
      address: product?.address || "",
      latitude: product?.latitude || "",
      longitude: product?.longitude || "",
      rating: product?.rating || "",
      noOfReviews: product?.noOfReviews || "",
      status: product?.status || "active",
      bookingStatus: product?.bookingStatus || 0,

      // 🔥 name se id nikal rahe hain
      category_id: selectedCategory?.id || "",
      state_id: selectedState?.id || "",

      amenities:
        product?.amenities?.map((a) => a.amenities_id) || [],

      images: [],
      thumbnail_image: null,
    }));
      if (product?.thumbnail_image) {
    setPreview(
      `${data?.imageBaseUrl}${product.thumbnail_image}`
    );
  }
  }, [product, dropdowns.categories, dropdowns.states]);
  useEffect(() => {
    if (!product || !dropdowns.subCategories.length) return;

    const selectedSubCategory = dropdowns.subCategories.find(
      (sub) =>
        sub.name?.toLowerCase() === product?.subcatName?.toLowerCase()
    );

    if (selectedSubCategory) {
      setFormData((prev) => ({
        ...prev,
        sub_category_id: selectedSubCategory.id,
      }));
    }
  }, [product, dropdowns.subCategories]);
  useEffect(() => {
    if (!product || !dropdowns.cities.length) return;

    const selectedCity = dropdowns.cities.find(
      (city) =>
        city.name?.toLowerCase() === product?.cityName?.toLowerCase()
    );

    if (selectedCity) {
      setFormData((prev) => ({
        ...prev,
        city_id: selectedCity.id,
      }));
    }
  }, [product, dropdowns.cities]);
  useEffect(() => {
    if (!product || !dropdowns.locations.length) return;

    const selectedLocation = dropdowns.locations.find(
      (loc) =>
        loc.name?.toLowerCase() === product?.location?.toLowerCase()
    );

    if (selectedLocation) {
      setFormData((prev) => ({
        ...prev,
        location_id: selectedLocation.id,
      }));
    }
  }, [product, dropdowns.locations]);
  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // IMAGE CHANGE
  const handleImageChange = (e) => {

    const file = e.target.files[0];

    if (file) {

      const imageUrl = URL.createObjectURL(file);

      setFormData((prev) => ({
        ...prev,
        thumbnail_image: file,
      }));

      setPreview(imageUrl);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const form = new FormData();

      form.append("id", id);

      form.append(
        "amenities",
        formData.amenities.join(",")
      );
      form.append("category_id", formData.category_id);
      form.append("state_id", formData.state_id);
      form.append("city_id", formData.city_id);
      form.append("location_id", formData.location_id);
      Object.keys(formData).forEach((key) => {

        if (
          key === "id" ||
          key === "amenities"
        ) return;

        if (key === "thumbnail_image") {

          if (formData.thumbnail_image) {

            form.append(
              "thumbnail_image",
              formData.thumbnail_image
            );
          }
        }

        else if (key !== "images") {
          form.append(key, formData[key]);
        }

      });

      // GALLERY IMAGES
      formData.images.forEach((img) => {

        form.append("images", img.file);

        form.append(
          "image_titles",
          img.title || ""
        );

      });

      const res =
        await updateProduct(form).unwrap();

      successToast(
        res?.message ||
        "Product Updated Successfully 🚀"
      );

      navigate("/product-list");

    } catch (error) {

      console.log(error);

      errorToast(
        error?.data?.message ||
        "Update Failed ❌"
      );
    }
  };

  if (productLoading) {
    return <h3>Loading...</h3>;
  }

  return (

    <div >
      <div className="page-header-breadcrumb all_breadcrumb">
        <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
          <nav>
            <h4 className="fw-semibold">
              Add Product
            </h4>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <navigate to="/">
                  Home
                </navigate>
              </li>

              <li
                className="breadcrumb-item active"
                aria-current="page"
              >
                Edit Product
              </li>

            </ol>

          </nav>

        </div>
        <div className="page-title fw-semibold fs-18 mb-0">

          <button
            className="btn btn-primary me-2"
            onClick={() => navigate(-1)}
          >

            <span>
              <i className="fe fe-shopping-cart me-1"></i>
            </span>

            Product List

          </button>

        </div>

      </div>
      <div className="card shadow p-4">

        <h3 className="mb-4">
          Edit Product
        </h3>

        <form onSubmit={handleSubmit}>

          <div className="row">

            {/* TITLE */}
            <div className="col-md-6 mb-3">

              <label className="form-label">
                Title
              </label>

              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                className="form-control"
              />

            </div>

            {/* PRICE */}
            <div className="col-md-6 mb-3">

              <label className="form-label">
                Price
              </label>

              <input
                type="number"
                name="price"
                value={formData.price}
                onChange={handleChange}
                className="form-control"
              />

            </div>

            {/* GUEST */}
            <div className="col-md-4 mb-3">

              <label>Guest</label>

              <input
                type="number"
                name="guest"
                value={formData.guest}
                onChange={handleChange}
                className="form-control"
              />

            </div>
            <div className="col-md-6 mb-3">

              <label>Category</label>

              <select
                name="category_id"
                value={formData.category_id}
                onChange={handleChange}
                className="form-control"
                className="form-control custumform"
              >
                <option value="">Select Category</option>

                {dropdowns.categories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
              </select>

            </div>

            <div className="col-md-6 mb-3">

              <label>Sub Category</label>

              {/* <input
                type="text"
                name="subcatName"
                value={formData.subcatName}
                onChange={handleChange}
                className="form-control"
              /> */}
              <select
                name="sub_category_id"
                className="form-control custumform"
                value={formData.sub_category_id}
                onChange={handleChange}
              >
                <option value="">Select SubCategory</option>

                {dropdowns.subCategories.map((sub) => (
                  <option key={sub.id} value={sub.id}>
                    {sub.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6 mb-3">

              <label>State</label>

              {/* <input
                type="text"
                name="stateName"
                value={formData.stateName}
                onChange={handleChange}
                className="form-control"
              /> */}
              <select
                name="state_id"
                value={formData.state_id}
                onChange={handleChange}
                className="form-control"
              >
                <option value="">Select State</option>

                {dropdowns.states.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6 mb-3">

              <label>City</label>

              {/* <input
                type="text"
                name="cityName"
                value={formData.cityName}
                onChange={handleChange}
                className="form-control"
              /> */}
              <select
                name="city_id"
                value={formData.city_id}
                onChange={handleChange}
                className="form-control custumform"
              >
                <option value="">Select City</option>

                {dropdowns.cities.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6 mb-3">

              <label>Location</label>

              {/* <input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
                className="form-control"
              /> */}
              <select
                name="location_id"
                value={formData.location_id}
                onChange={handleChange}
               className="form-control custumform"
              >
                <option value="">Select Location</option>

                {dropdowns.locations.map((l) => (
                  <option key={l.id} value={l.id}>
                    {l.name}
                  </option>
                ))}
              </select>
            </div>
            {/* 
            <div className="col-md-6 mb-3">

              <label>Discount Price</label>

              <input
                type="number"
                name="discount_price"
                value={formData.discount_price}
                onChange={handleChange}
                className="form-control"
              />

            </div> */}

            <div className="col-md-6 mb-3">

              <label>Booking Status</label>

              <select
                name="bookingStatus"
                value={formData.bookingStatus}
                onChange={handleChange}
                className="form-select"
              >

                <option value="0">
                  Available
                </option>

                <option value="1">
                  Booked
                </option>

              </select>

            </div>

            {/* <div className="col-md-6 mb-3">

              <label>Amenities</label>

              <input
                type="text"
                name="amenities"
                value={formData?.amenities?.join(",") || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    amenities: e.target.value
                      .split(",")
                      .map((item) => item.trim()),
                  }))
                }
                className="form-control"
                placeholder="1,2,3,4"
              />

            </div> */}
            {/* BEDROOM */}
            <div className="col-md-4 mb-3">

              <label>Bedroom</label>

              <input
                type="number"
                name="bedroom"
                value={formData.bedroom}
                onChange={handleChange}
                className="form-control"
              />
            </div>

            {/* BED */}
            <div className="col-md-4 mb-3">

              <label>Bed</label>

              <input
                type="number"
                name="bed"
                value={formData.bed}
                onChange={handleChange}
                className="form-control"
              />

            </div>

            {/* BATHROOM */}
            <div className="col-md-6 mb-3">

              <label>Bathroom</label>

              <input
                type="number"
                name="bathroom"
                value={formData.bathroom}
                onChange={handleChange}
                className="form-control"
              />

            </div>

            {/* RATING */}
            <div className="col-md-6 mb-3">

              <label>Rating</label>

              <input
                type="number"
                name="rating"
                value={formData.rating}
                onChange={handleChange}
                className="form-control"
              />

            </div>
            <div className="col-md-6 mb-3">

              <label>No Of Reviews</label>

              <input
                type="number"
                name="noOfReviews"
                value={formData.noOfReviews}
                onChange={handleChange}
                className="form-control"
              />

            </div>
          </div>

          {/* DESCRIPTION */}
          <div className="mb-3">

            <label>Description</label>

            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows="4"
              className="form-control"
            />

          </div>

          {/* ADDRESS */}
          <div className="mb-3">

            <label>Address</label>

            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              className="form-control"
            />

          </div>

          {/* LAT LONG */}
          <div className="row">

            <div className="col-md-6 mb-3">

              <label>Latitude</label>

              <input
                type="text"
                name="latitude"
                value={formData.latitude}
                onChange={handleChange}
                className="form-control"
              />

            </div>

            <div className="col-md-6 mb-3">

              <label>Longitude</label>

              <input
                type="text"
                name="longitude"
                value={formData.longitude}
                onChange={handleChange}
                className="form-control"
              />

            </div>

          </div>

          {/* IMAGE */}
          <div className="mb-3">

            <label>
              Thumbnail Image
            </label>

            <input
              type="file"
              className="form-control"
              accept="image/*"
              onChange={handleImageChange}
            />

            {preview ? (
              <div className="mt-3">

                <p className="fw-bold">
                  Current Image
                </p>

                <img
                  src={preview}
                  alt="preview"
                  width="120"
                  style={{
                    borderRadius: "10px",
                    objectFit: "cover",
                  }}
                />

              </div>
            ) : (
              <p className="text-muted mt-2">
                No Image Available
              </p>
            )}

          </div>

          {/* <div className="mb-3">

            <label className="form-label">
              Product Gallery Images
            </label>
            <input
              type="file"
              multiple
              className="form-control"
              accept="image/*"
              onChange={(e) => {
                const files = Array.from(e.target.files);

                const newImages = files.map((file) => ({
                  file,
                  preview: URL.createObjectURL(file),
                  title: "",
                }));

                setFormData((prev) => ({
                  ...prev,
                  images: [...prev.images, ...newImages],
                }));

                setGalleryPreview((prev) => [
                  ...prev,
                  ...newImages.map((img) => ({
                    image: img.preview,
                    title: "",
                    old: false,
                  })),
                ]);
              }}
            />
                  {galleryPreview.length > 0 && (

              <div className="row mt-4">

                {galleryPreview.map((img, index) => (

                  <div
                    className="col-md-3 mb-3"
                    key={index}
                  >

                    <div className="card p-2">

                      <img
                        src={
                          img.old
                            ? `${data?.imageBaseUrl}${img.image}`
                            : img.preview
                        }
                        alt="gallery"
                        height="180"
                        style={{
                          width: "100%",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                      />

                      <input
                        type="text"
                        placeholder="Image Title"
                        className="form-control mt-2"
                        value={img.title || ""}
                        onChange={(e) => {

                          const updated =
                            [...galleryPreview];

                          updated[index].title =
                            e.target.value;

                          setGalleryPreview(updated);
                        }}
                      />

                    </div>

                  </div>

                ))}

              </div>

            )}
          </div> */}
<div className="col-md-12 mb-3">
  <label className="form-label fw-semibold">
    Amenities
  </label>

  <div className="row border rounded p-3">

    {dropdowns.amenities?.map((item) => (
      <div
        className="col-md-3 col-sm-6 mb-2"
        key={item.id}
      >
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id={`amenity-${item.id}`}
            checked={formData.amenities.includes(
              item.id
            )}
            onChange={(e) => {

              if (e.target.checked) {

                setFormData((prev) => ({
                  ...prev,
                  amenities: [
                    ...prev.amenities,
                    item.id,
                  ],
                }));

              } else {

                setFormData((prev) => ({
                  ...prev,
                  amenities: prev.amenities.filter(
                    (id) => id !== item.id
                  ),
                }));

              }

            }}
          />

          <label
            className="form-check-label"
            htmlFor={`amenity-${item.id}`}
          >
            {item.name}
          </label>

        </div>
      </div>
    ))}

  </div>
</div>
          {/* STATUS */}
          <div className="mb-3">

            <label>Status</label>

            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className="form-select"
            >

              <option value="active">
                Active
              </option>

              <option value="inactive">
                Inactive
              </option>

            </select>

          </div>

          {/* BUTTON */}
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >

            {isLoading
              ? "Updating..."
              : "Update Product"}

          </button>

        </form>

      </div>

    </div>
  );
}

export default EditProduct;